import { Fragment, useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from 'react-toastify'

import Header from "../component/layout/header";
import Footer from "../component/layout/footer";
import PageHeader from "../component/layout/pageheader";
import SocialMedia from "../component/section/socialmedia";

import { ShopContext } from "../context/ShopContext";

const Login = () => {
  const { backendUrl, setToken } = useContext(ShopContext);
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmitHandler = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);

      const response = await axios.post(
        `${backendUrl}/api/user/login`,
        { email, password }
      );

      if (response.data.success) {
        localStorage.removeItem("token");
        setToken(response.data.token);
        navigate("/");
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error(error);
      toast.error("Login failed");
    } finally {
      setLoading(false);
    }
    
  };

  return (
    <Fragment>
      <Header />
      <PageHeader title="Login to Your Account" curPage="Login" />

      <div className="login-section padding-top padding-bottom">
        <div className="container">
          <div className="account-wrapper">
            <h3 className="title">Login</h3>

            <form className="account-form" onSubmit={onSubmitHandler}>
              <div className="form-group">
                <input
                  type="email"
                  placeholder="Email *"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>

              <div className="form-group">
                <input
                  type="password"
                  placeholder="Password *"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>

              <div className="form-group d-flex justify-content-between flex-wrap pt-sm-2">
                <div className="checkgroup">
                  <input type="checkbox" id="remember-me" />
                  <label htmlFor="remember-me">Remember Me</label>
                </div>
                <Link to="#">Forget Password?</Link>
              </div>

              <div className="form-group">
                <button
                  type="submit"
                  className="d-block default-button"
                  disabled={loading}
                >
                  <span>{loading ? "Logging in..." : "Submit Now"}</span>
                </button>
              </div>
            </form>

            <div className="account-bottom">
              <span className="d-block cate pt-10">
                Don’t Have an Account? <Link to="/signup">Sign Up</Link>
              </span>

              <span className="or">
                <span>or</span>
              </span>

              <h5 className="subtitle">Login With Social Media</h5>
              <ul className="match-social-list d-flex flex-wrap align-items-center justify-content-center mt-4">
                <SocialMedia />
              </ul>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </Fragment>
  );
};

export default Login;
